const $ = window.jQuery;

$(window).load(() => {
    const $topNavLocation = $('.top-nav-location');
    const $topNavLocationImg = $('> img', $topNavLocation);
    const $topNavLocationText = $('> span', $topNavLocation);
    const $topMobileNavLocationText = $('#m-location');
    const $body = $('body');

    // console.log(locationsData);

    /**
     * Updates the link in the top right.
     * @param {string} name The name of the location.
     * @param {string} url The URL of the location.
     */
    function updateLocationLink(name, url) {
        $topNavLocationText.text(name);
        $topMobileNavLocationText.text(name);
        $topNavLocation.attr('href', url);
    }

    /**
     * Updates the variable for the user location.
     * @param {number} id
     * @param {string} name
     * @param {string} url
     */
    function updateLocationVar(id, name, url) {
        window.fogoSavedLocation = {
            id,
            name,
            url,
        };

        const updateEvent = new CustomEvent('fogoUserLocationUpdated', {
            bubbles: false,
            detail: window.fogoSavedLocation,
        });

        window.dispatchEvent(updateEvent);
    }

    /**
     * Returns the location requeste in the URL or false.
     */
    function getLocationRequested() {
        const locationParam = window.location.search.match(/location=([0-9]+)/);

        return locationParam === null ? false : parseInt(locationParam[1], 10);
    }

    // Layer to manage data stored in localStorage.
    const db = {
        key: 'fogo_restaurantSelected',
        load() {
            try {
                const data = JSON.parse(window.localStorage.getItem(db.key));

                if (data === null) {
                    throw new Error();
                }

                updateLocationVar(data.id, data.name, data.url);
            } catch {
                updateLocationVar(null, null, null);
            }
        },
        save(data) {
            window.localStorage.setItem(db.key, JSON.stringify(data));
        },
    };

    if (typeof window.fogoSavedLocation === 'undefined') {
        db.load();
    }

    window.fogoChangeTopLocation = (name, url, id) => {
        updateLocationVar(id, name, url);
        updateLocationLink(name, url);

        db.save(window.fogoSavedLocation);
    };

    $topNavLocationImg.hide();

    if ($body.is('.single-restaurants')) {
        const $locationInfo = $('.js-location-name');

        window.fogoChangeTopLocation(
            $locationInfo.text(),
            window.location.href.split('#')[0],
            $locationInfo.data('id'),
        );

        return;
    }

    if (
        $body.is('.post-type-archive-menu-category') &&
        $('#js-locations').length === 1
    ) {
        if (
            getLocationRequested() === false &&
            window.fogoSavedLocation.id > 0
        ) {
            window.location.href = [
                '/menu/?location=',
                window.fogoSavedLocation.id,
            ].join('');
            return;
        }
    }

    if (window.fogoSavedLocation.name !== null) {
        updateLocationLink(
            window.fogoSavedLocation.name,
            window.fogoSavedLocation.url,
        );
        return;
    }

    $topNavLocationText.text(fogo_l10n.text.selectLocation);
});
